export default __webpack_public_path__ + "56a82359ebe22eaae14ef4a2e1edbbf6.ttf";